import React from 'react'
import { Spinner } from 'react-bootstrap'
import './loadingMask.css'

const LoadingMask = (props) => {

  return (
    <div className={`loading-mask ` + props.ctrlCss}
      aria-live={`polite`}>
      <Spinner animation="border" />
      {!props.hideText && <span> {props.text || "Loading ..."} </span>}
      <span className="sr-only">{props.NavigationLink} Page. Please wait.</span>
    </div>);
}

export default LoadingMask;